'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = (0, _react.memo)(function (_ref) {
	var className = _ref.className,
	    title = _ref.title,
	    titleClassName = _ref.titleClassName;

	var cnLoader = (0, _classnames2.default)("toolkit_loader", className);

	return _react2.default.createElement(
		'div',
		{ className: cnLoader },
		_react2.default.createElement(
			'div',
			{ className: 'bnc_loader' },
			_react2.default.createElement('span', null),
			_react2.default.createElement('span', null),
			_react2.default.createElement('span', null)
		),
		title && _react2.default.createElement(
			'span',
			{ className: titleClassName },
			title
		)
	);
});